/** Shared text styles for shutdown settings accordion panels (dark mode fix). */
export const shutdownText = (theme, opacity = 0.9) =>
  theme === 'dark' ? { color: '#ffffff', opacity } : {};

export const shutdownHeading = (theme) =>
  theme === 'dark' ? { color: '#ffffff', opacity: 0.95 } : { color: '', opacity: 1 };

export const shutdownInnerFormStyle = (theme) => ({
  background: theme === 'dark' ? '#000000' : '',
  color: theme === 'dark' ? '#ffffff' : '',
});
